import type { FC } from 'react';
import { QIconButton } from '../../../QAtoms';
import { useQPropertiesPanelStateContext } from '../context';
import { useLibraryTranslation } from '../../../i18n';

/**
 * A button that toggles the properties panel when clicked.
 * Displays a left-pointing chevrons when the panel is closed,
 * and a right-facing chevron when the panel is open.
 */
export const QTogglePropertiesPanelButton: FC = () => {
  const { t } = useLibraryTranslation();
  const {
    disclosure: { isOpen, onToggle },
  } = useQPropertiesPanelStateContext();
  return (
    <QIconButton
      iconName={isOpen ? 'ChevronsRight' : 'ChevronsLeft'}
      aria-label={t('propertiesPanel.toggle')}
      onClick={onToggle}
    />
  );
};
